$('.page-content.sobre .valuations').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    responsiveClass:true,
    responsive:{
        768:{
            items:2,
        },
        1000:{
            items:3,
        }
    }
});